import { Controller, useFormContext, useFormState } from 'react-hook-form';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, TextField, Typography } from '@mui/material'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';
import Select from "react-select"; 

export const AgregarCapacitacionesEmpleadosModal = ( { open = {}, setOpen, onSaveEmpleado, empleadosListState = [], estudiosGradosState = [] }) => {

  // ? HOOK-FORM
  const { control, handleSubmit, setValue, reset } = useFormContext();

  // * OBTENER Y PERMANECER ERRORES PARA EVITAR ERRORES DE RENDERIZADO.
  const { errors } = useFormState({
    control,
    name: ['empleado.empleadoId', 'empleado.nombreGradoAlcanzado', 'empleado.gradoAlcanzado'],
  });

  return (
    <Dialog
    PaperProps={{ sx: { width: "50%", height: "70%" } }}
    open={open?.open}
    maxWidth='lg'
    >

      <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>{open?.edit ? "Editar" : "Agregar"} Empleados Capacitación</DialogTitle>
      <Divider />

      <DialogContent>

        <Stack mt={2} mb={2}>

          <form id='formAgregarEmpleados' onSubmit={handleSubmit(onSaveEmpleado)}>
            <Stack>
              <Typography fontWeight='bold'>Empleado</Typography>
              <Controller
              control={control}
              name='empleado.empleadoId'
              render={({ field }) => (
                <Select
                  isDisabled={open?.edit}
                  id='select-empleado'
                  classNamePrefix="select"
                  isSearchable={true}
                  placeholder="Seleccionar Empleado"
                  options={empleadosListState} 
                  getOptionLabel={(option) => option.nombreLabel}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => {
                    field.onChange(e.id);
                    setValue('empleado.nombreEmpleado', e.nombreLabel)
                  }}
                  value={empleadosListState.find(x => x.id === field.value)}
                />
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.empleado?.empleadoId?.message}>{errors?.empleado?.empleadoId?.message}</p>
            </Stack>


            <Stack mt={2}>
              <Typography fontWeight='bold'>Nombre de Grado Alcanzado</Typography>
              <Controller 
              control={control}
              name='empleado.nombreGradoAlcanzado'
              render={({field}) => (
                  <TextField 
                  sx={{minWidth: '100%'}}
                  variant='outlined' 
                  onChange={(e) => field.onChange(e)}
                  value={field.value}
                  />
              )}
              /> 

              <p className='text-danger mb-0' hidden={!errors?.empleado?.nombreGradoAlcanzado?.message}>{errors?.empleado?.nombreGradoAlcanzado?.message}</p>
            </Stack>

            <Stack mt={2}>
              <Typography fontWeight='bold'>Tipo de Grado</Typography>
              <Controller
              control={control}
              name='empleado.gradoAlcanzado'
              render={({ field }) => (
                <Select
                  id='select-empleado'
                  classNamePrefix="select"
                  isSearchable={true}
                  placeholder="Seleccionar Grado"
                  options={estudiosGradosState} 
                  getOptionLabel={(option) => option.descripcion}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => {
                    field.onChange(e.id);
                    setValue('empleado.tipo', e.descripcion)
                  }}
                  value={estudiosGradosState.find(x => x.id === field.value)}
                />
              )}
              />

              <p className='text-danger mb-0' hidden={!errors?.empleado?.gradoAlcanzado?.message}>{errors?.empleado?.gradoAlcanzado?.message}</p>
            </Stack>
             
          </form>
           
        </Stack>
           
      </DialogContent>

      <DialogActions className='justify-content-center'>
        <button type='button'onClick={() => {
          setOpen({ open: false, edit: false, empleado: {}});
          reset();
        }} className='btn btn-danger'><DoNotDisturbAltIcon sx={{marginTop: -0.5, marginRight: 0.5}} />CANCELAR</button>
        <button form='formAgregarEmpleados' type='submit' className='btn btn-primary-mem'><SaveIcon sx={{marginTop: -0.5, marginRight: 0.5}} />GUARDAR</button>
      </DialogActions>

    </Dialog>
  )
}
